import { ThreeEvent } from "@react-three/fiber";
import { Object3D, Vector2 } from "three";
import { coordsToPosition } from "../../../e.elements/Grid/scripts/helpers/coordsPositionConverter";
import { useScenesStore } from "../../../b.providers/ScenesProvider/store";
import { useSceneStore } from "../../../a.scenes/GameScene/store";
import { Tile } from "../store.d";
import { Terrain } from "../../../d.controllers/TerrainController";
import { SEL_GRID_ORIGIN } from "../selectors";

export const addElementToGrid = (obj: Object3D) => {
  if(!obj.userData.coords) return false

  Terrain.moveObject(obj, obj.userData.coords)
  const gridOrigin = SEL_GRID_ORIGIN(useSceneStore.getState())
  obj.position.copy(coordsToPosition(obj.userData.coords, gridOrigin))
}

export const setRandomPosition = (obj: Object3D) => {
  const grid = useScenesStore.getState().getGameElement('gridElement')?.userData.grid as Tile[][]
  if(!grid) return false
  
  let isEmpty = false
  let x, y = 0
  do {
    x = Math.floor(Math.random() * (grid.length -1))
    y = Math.floor(Math.random() * (grid[0].length -1))
    
    isEmpty = grid[x][y].isEmpty()
  } while(isEmpty === false)
  obj.userData.coords = new Vector2(x, y)
}

export const onPointerEnterHandler = (event: ThreeEvent<Event>) => {
  // console.log('over', event.eventObject);
}